import { patterns } from '../../../constants/patterns';

export const validatePhone = (value: string | undefined | null) =>
  !value || patterns.PHONE.test(value) || 'Invalid format: +1 (752) 000 0000';
